import "core-js/stable";
import "regenerator-runtime/runtime";
import setup from "./setup";

setup();
